import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProposalForm from "./Pages/ProposalForm/ProposalForm.js";
import Loading from "./Pages/Loading/Loading.js";
import CreatePDF from "./Pages/CreatePDF/CreatePDF.js";
import Home from "./Pages/Home/Home.js"
import Freight from "./Pages/Freight/Freight.js"
import Proposals from "./Pages/Proposals/Proposals.js";
import Login from "./Pages/Login/Login.js";
import AppLayout from "./Shared/Layout/AppLayout.js";
import { ToastProvider } from "./Componenets/Toast/Toast.js";
import { AuthProvider } from "./Shared/Auth/AuthContext.js";
import { CAMINHO_LOGIN, RotaProtegida, RotaPublica } from "./Shared/Auth/Rotas.js";

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route element={<RotaPublica />}>
              <Route path={CAMINHO_LOGIN} element={<Login />} />
            </Route>

            {/* Todo o ERP exige sessao */}
            <Route element={<RotaProtegida />}>
              {/* Telas com a barra lateral */}
              <Route element={<AppLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/Propostas" element={<Proposals />} />
                <Route path="/Cotação-Frete" element={<Freight />} />
                <Route path="/Proposta-Comercial" element={<ProposalForm />} />
              </Route>
              {/* Telas em tela cheia (geração e impressão do PDF) */}
              <Route path="Loading" element={<Loading />} />
              <Route path="/PDF-Proposta-Comercial" element={<CreatePDF />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
